export default {
  title: 'Dados do fornecedor',
  contractReferenceTooltip: 'Para Bankia/Caixa, a referência de contrato é obrigatória. O campo aceita apenas um T e no máximo 7 dígitos (Ex: T1234567)',
  contractReferenceTooltipEurobits: 'Somente quando a fatura é emitida para Bankia/Caixa. A referência de contrato é obrigatória. O campo aceita apenas um T e no máximo 7 dígitos (Ex: T1234567)',
  invalidData: 'Os dados do fornecedor registrados não estão corretos. Você deve atualizá-los em "Dados gerais" e "Agenda"'
}